// extracted by mini-css-extract-plugin
export default {"dish-image-shield__img":"dish-image-shield__img___Kj9LB"};